:host {
  display: inline-block;
  --size: var(--sportsline-player-avatar-size, 2.25rem);
  height: fit-content;
}

img {
  display: block;
}

.sportsline-player-avatar {
  border-radius: 50%;
  background-color: var(--sportsline-player-avatar-background-color, #c2c2c2);
  width: var(--size);
  height: var(--size);
}

.sportsline-player-avatar--small {
  width: var(--sportsline-team-logo-size-small, 1.25rem);
  height: var(--sportsline-team-logo-size-small, 1.25rem);
}
.sportsline-player-avatar--medium {
  width: var(--sportsline-player-avatar-size-medium, 2.625rem);
  height: var(--sportsline-player-avatar-size-medium, 2.625rem);
}
.sportsline-player-avatar--large {
  width: var(--sportsline-player-avatar-size-large, 3rem);
  height: var(--sportsline-player-avatar-size-large, 3rem);
}
.sportsline-player-avatar--extra-large {
  width: var(--sportsline-player-avatar-size-extra-large, 3.75rem);
  height: var(--sportsline-player-avatar-size-extra-large, 3.75rem);
}
